<template>
  <div>
    <h6 class="altblok">Müşteriler
      <el-button-group class="float-right YeniBtn">
        <el-button type="info" size="mini" @click="SayfaYukle()">
          Yenile
        </el-button>
      </el-button-group>
    </h6>
    <el-table
      v-if="Liste"
      :data="Liste"
      height="90vh"
      @current-change="TableSecim">
      <el-table-column
        label="Tarih"
        prop="tarih"
        width="100">
      </el-table-column>
      <el-table-column
        label="Telefon"
        prop="Telefon"
        width="100">
      </el-table-column>
      <el-table-column
        label="İsim"
        prop="AdSoyad">
      </el-table-column>
    </el-table>
    <Yukleniyor :data="lo"></Yukleniyor>
  </div>
</template>

<script>
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  data() {
    return {
      Liste: null,
      lo: false
    }
  },
  methods: {
    TableSecim(val) {
      console.log(val)
    },

    SayfaYukle() {
      this.DonemModalDurum = false
      this.lo = true
      this.$store.dispatch("Get", {path: '_ju/musteri'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Liste = response.Liste;
            this.lo = false
          } else {
            this.$message.error(response.Mesaj);
          }
        });

    }
  },
  created() {
    this.SayfaYukle()

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/JetUsta/Comp/juKayit.vue